import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { NotificationItem } from "@ServerTypes/notifications/notifications.schema";

type NotificationsStatusState = Record<string, NotificationItem>;

const notificationsStatusSlice = createSlice({
  name: "notificationsStatus",
  initialState: {} as NotificationsStatusState,
  reducers: {
    setNotificationsStatusesData: (_state: NotificationsStatusState, action: PayloadAction<NotificationItem[]>) =>
      action.payload.reduce(
        (prev: NotificationsStatusState, curr: NotificationItem) => ({ ...prev, [curr._id]: curr }),
        {},
      ),
  },
});

const unreadNotificationsCountSlice = createSlice({
  name: "unreadNotificationsCount",
  initialState: 0,
  reducers: {
    setUnreadNotificationsCount: (_state: number, action: PayloadAction<number>) => action.payload,
  },
});

const showNotificationSlice = createSlice({
  name: "showNotification",
  initialState: false,
  reducers: {
    setShowNotification: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const notificationsDataSlice = createSlice({
  name: "notificationsData",
  initialState: [] as NotificationItem[],
  reducers: {
    setNotificationsData: (_state: NotificationItem[], action: PayloadAction<NotificationItem[]>) => action.payload,
    readNotificationsData: (state: NotificationItem[], action: PayloadAction<string[]>) =>
      state.map((notification: NotificationItem) => {
        if (action.payload.indexOf(notification._id) !== -1) {
          notification.read = "NOTIFICATION_READ";
        }
        return notification;
      }),
    unreadNotificationsData: (state: NotificationItem[], action: PayloadAction<string[]>) =>
      state.map((notification: NotificationItem) => {
        if (action.payload.indexOf(notification._id) !== -1) {
          notification.read = "NOTIFICATION_UNREAD";
        }
        return notification;
      }),
  },
});

export const { setNotificationsStatusesData } = notificationsStatusSlice.actions;
export const { setUnreadNotificationsCount } = unreadNotificationsCountSlice.actions;
export const { setShowNotification } = showNotificationSlice.actions;
export const { setNotificationsData, readNotificationsData, unreadNotificationsData } = notificationsDataSlice.actions;

export const notificationsStatus = notificationsStatusSlice.reducer;
export const unreadNotificationsCount = unreadNotificationsCountSlice.reducer;
export const showNotification = showNotificationSlice.reducer;
export const notificationsData = notificationsDataSlice.reducer;

export default {
  notificationsStatus,
  unreadNotificationsCount,
  showNotification,
  notificationsData,
};
